module.exports = __webpack_public_path__ + "img/1438849221.c27eda69.jpg";